var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container side-by-side" }, [
    _c(
      "div",
      { staticClass: "row" },
      [_c("search-area", { staticClass: "col-12" })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row search-loading__parent" },
      [
        _c("search-categories", { staticClass: "col-4" }),
        _vm._v(" "),
        _c("search-results", { staticClass: "col-8" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }